import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';

interface AdminContext {
  isBackModalOpen: boolean;
  setIsBackModalOpen: Dispatch<SetStateAction<boolean>>;
  isDirty: boolean;
  setIsDirty: Dispatch<SetStateAction<boolean>>;
}

const Context = createContext<AdminContext>({
  isBackModalOpen: false,
  setIsBackModalOpen: () => {},
  isDirty: false,
  setIsDirty: () => {},
});

export const useAdmin = () => useContext(Context);

export const AdminProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isBackModalOpen, setIsBackModalOpen] = useState<boolean>(false);
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const value: AdminContext = {
    isBackModalOpen,
    setIsBackModalOpen,
    isDirty,
    setIsDirty,
  };

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
